<template>
  <Modal v-model="showModal" :title='selftitle' :mask-closable='false' width='800px'>
    <div style='position:relative;clear:both;min-height:400px;overflow:hidden;'>
      <Form label-position="top" ref='formCustom' v-for='(item, index) in formdata[1]' :key='index'>
        <FormItem :label="item.title" v-if='item.type == "rangetime"' :class='[item.block ? "nor" : "act"]'>
          <!-- <DatePicker format="yyyy-MM-dd" type="daterange" placement="bottom-end" placeholder="选择日期" style='width:100%;'></DatePicker> -->
          <DatePicker type="datetimerange" v-model='item.model' format="yyyy-MM-dd HH:mm" placeholder="选择时间"
            style="width: 100%"></DatePicker>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "datetime"' :class='[item.block ? "nor" : "act"]'>
          <!-- <DatePicker format="yyyy-MM-dd" type="daterange" placement="bottom-end" placeholder="选择日期" style='width:100%;'></DatePicker> -->
          <DatePicker type="datetime" v-model='item.model' format="yyyy-MM-dd HH:mm" placeholder="选择时间"
            style="width: 100%"></DatePicker>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "date"' :class='[item.block ? "nor" : "act"]'>
          <DatePicker type="date" v-model='item.model' format="yyyy-MM-dd" placeholder="选择时间" style="width: 100%">
          </DatePicker>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "input"' :class='[item.block ? "nor" : "act"]'>
          <Input v-model="item.model" :disabled='item.disabled' type='text'></Input>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "numberInput"' :class='[item.block ? "nor" : "act"]'>
          <InputNumber v-model="item.model" :max='maxnum' :min='minnum' style="width: 100%">
          </InputNumber>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "timerange"' :class='[item.block ? "nor" : "act"]'>
          <TimePicker type="timerange" v-model="item.model" :clearable='true' format='HH:mm' style="width: 100%"
            confirm>
          </TimePicker>
        </FormItem>

        <FormItem :label="item.title" v-if='item.type == "time"' :class='[item.block ? "nor" : "act"]'>
          <TimePicker type="time" v-model="item.model" :clearable='true' format='HH:mm' style="width: 100%">
          </TimePicker>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "textarea"' :class='[item.block ? "nor" : "act"]'>
          <Input v-model="item.model" type='textarea' :rows="3"></Input>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "checkbox"' :class='[item.block ? "nor" : "act"]'>
          <Checkbox v-for='(items, indexs) in item.children' :key='indexs' v-model='items.model'>
            &nbsp;{{ items.title }} </Checkbox>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "radio"' :class='[item.block ? "nor" : "act"]'>
          <RadioGroup v-model="item.model">
            <Radio v-for='(items, indexs) in item.children' :key='indexs' :label='items.title'></Radio>
          </RadioGroup>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "switch"' class='switchclass'
          :class='[item.block ? "nor" : "act"]'>
          <i-switch v-model="item.model" />
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "select"' :class='[item.block ? "nor" : "act"]'>
          <Select v-model="item.model" :placeholder="item.placeholder">
            <Option v-for='(items, indexs) in item.children' :key='indexs' :value="items.value">
              {{ items.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "multSelect"' :class='[item.block ? "nor" : "act"]'>
          <Select v-model="item.model" multiple :placeholder="item.placeholder">
            <Option v-for='(items, indexs) in item.children' :key='indexs' :value="items.value">
              {{ items.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "pkselect"' :class='[item.block ? "nor" : "act"]'>
          <Select v-model="item.model" :placeholder="item.placeholder">
            <Option v-for='(items, indexs) in item.children' :key='indexs' :value="items.guid">
              {{ items.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "cascader"' :class='[item.block ? "nor" : "act"]'>
          <Cascader :data="schoolData" trigger="hover" :value='item.model'></Cascader>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "selectRole"' :class='[item.block ? "nor" : "act"]'>
          <Select v-model="item.model" multiple :max-tag-count='2'>
            <Option v-for="(items, indexs) in roleData" :value="items.id" :key="items.id">{{ items.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "selectApp"' :class='[item.block ? "nor" : "act"]'>
          <Select v-model="item.model">
            <Option v-for="items in appcenterData" :value="items.guid" :key="items.guid">{{ items.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "selectRoot"' :class='[item.block ? "nor" : "act"]'>
          <Select v-model="item.model">
            <Option v-for="items in rootData" :value="items.guid" :key="items.guid">{{ items.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "selectVideo"' :class='[item.block ? "nor" : "act"]'>
          <Select v-model="item.model">
            <Option v-for="items in videoData" :value="items.guid" :key="items.guid">{{ items.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "selectAudio"' :class='[item.block ? "nor" : "act"]'>
          <Select v-model="item.model">
            <Option v-for="items in audioData" :value="items.guid" :key="items.guid">{{ items.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "selectParts"' :class='[item.block ? "nor" : "act"]'>
          <Select v-model="item.model" multiple :max-tag-count='2'>
            <Option v-for="items in partData" :value="items.id" :key="items.id">{{ items.name }}</Option>
          </Select>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "selectLcd"' :class='[item.block ? "nor" : "act"]'>
          <Select v-model="item.model" multiple :max-tag-count='2'>
            <Option v-for="items in lcdData" :value="items" :key="items">{{ items }}</Option>
          </Select>
        </FormItem>

        <FormItem :label="item.title" v-if='item.type == "selectSign"' :class='[item.block ? "nor" : "act"]'>
          <Select v-model="item.model">
            <Option v-for="items in signData" :value="items.guid" :key="items.guid">{{ items.remark }}
            </Option>
          </Select>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "selectPart"' :class='[item.block ? "nor" : "act"]'>
          <Select v-model="item.model" multiple>
            <Option v-for="items in item.children" :value="items.id" :key="items.id">{{ items.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "selectTree"' :class='[item.block ? "nor" : "act"]'>
          <super-tree-select v-model='item.model' :data='schoolData' width="100%"></super-tree-select>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "selectMutl"' :class='[item.block ? "nor" : "act"]'>
          <Select v-model="item.model" multiple>
            <Option v-for="items in objlist" :value="items.value" :key="items.value">{{ items.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "remark"' :class='[item.block ? "nor" : "act"]'>


          <Alert show-icon>

            <template slot="desc">
              {{ item.model }}
            </template>
          </Alert>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "upImgnew"' :class='[item.block ? "nor" : "act"]'>
          <input type="hidden" v-model='item.model'>
          <upImgnew @upImglist='upImglist' :extradata='item.pictype' :defaultimg='item.model' :datanum='treekey'
            :defaultname='item.name' :max-len='item.len'></upImgnew>

        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "uploadimg"' :class='[item.block ? "nor" : "act"]'>
          <input type="hidden" v-model='item.model'>
          <upImg @upImglist='upImglist' :extradata='item.pictype' :defaultimg='item.model' :datanum='treekey'
            :defaultname='item.name' :max-len='item.len' :maxLen="item.len"></upImg>
          <p style='color:#e22a1c'>图片尺寸：{{ item.pictype.size }}</p>
        </FormItem>
        <FormItem v-if='item.type == "transfer"' :label="item.title">
          <Transfer :data="alluser" :target-keys="targetUser" filterable :not-found-text="''" :reverse-operation='true'
            :titles="['待选列表', '已选列表']" @on-change="changeUsers"></Transfer>
        </FormItem>
        <FormItem v-if='item.type == "partuser"' label="部门人员">
          <div id='partGroup'>
            <Button type='success' size='small' v-for='(item, index) in partUserData'
              :class="{ 'active': btnAct == index, 'btnNor': item.checkUser > 0 }" :key='item.id' :id="item.id"
              @click='renderUser(item.id, index, item.children)' style='height:20px;'>{{ item.name }}
              <span v-if='item.checkUser > 0'>{{ item.checkUser }}</span></Button>
          </div>
          <Transfer :data="users" :target-keys="targetKeys" filterable :not-found-text="''" :reverse-operation='true'
            :titles="['待选列表', '已选列表']" @on-change="changeUser"></Transfer>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "video"'>
          <video id="myvideo" width="350" height="196" :src="item.model" v-if='item.model' controls="controls"
            style="display:inline;">
            <source id="tv" type="video/mp4" :src="item.model">
            视频
            </source>
            您的浏览器不支持video标签
          </video>
          <Upload :action="actionUrl" :on-success='upVideo' :on-format-error="handleFormatErrorAudio" ref="videoUpload">
            <Button icon="ios-cloud-upload-outline">上传视频</Button>
          </Upload>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "audio"'>
          <Input v-model="audioUrl" type='text'></Input>

          <Upload :action="actionUrl" :on-success='upAudio' :on-format-error="handleFormatError" ref="upAudioUpload"
            style='margin-top:10px;'>
            <Button icon="ios-cloud-upload-outline">上传音频</Button>
          </Upload>
        </FormItem>
        <FormItem label="上传文件" v-if='item.type == "file"'>
          <upFile @emitParent='getPhotoList' :extradata='item.pictype' :checkList='formCustom.pic' :hasName='false'>
          </upFile>
        </FormItem>


        <FormItem :label="item.title" v-if='item.type == "excelfile"' :class='[item.block ? "nor" : "act"]'>
          <Input v-model="selfUrl" type='text'></Input>
          <Upload :action="actionUrl" style='margin-top:20px' :show-upload-list='false' ref="videoUpload"
            :on-success="handleSuccess">
            <Button icon="ios-cloud-upload-outline">上传文件</Button>
          </Upload>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "uploadpic"' :class='[item.block ? "nor" : "act"]'>
          <img :src="item.model" alt="" style='width:40px;height:40px'>
          <Upload :action="actionUrl" :show-upload-list='false' ref="videoUpload" :on-success="pichandleSuccess">
            <Button icon="ios-cloud-upload-outline">上传文件</Button>
          </Upload>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "uploadpic2"' :class='[item.block ? "nor" : "act"]'>
          <img :src="item.model" alt="" style='width:40px;height:40px'>
          <Upload :action="actionUrl" :show-upload-list='false' ref="videoUpload" :on-success="pichandleSuccess2">
            <Button icon="ios-cloud-upload-outline">上传文件</Button>
          </Upload>
        </FormItem>
        <FormItem :label="item.title" v-if='item.type == "wangeditor"' :class='[item.block ? "nor" : "act"]'>
          <wang @editorContent='editorContent' :nr='item.model'></wang>
        </FormItem>
        <FormItem v-if='item.type == "hidden"' style='display:none;clear:both'>
          <Input v-for='(items, indexs) in item.children' :key='indexs' v-model="items.model" type='text'></Input>
        </FormItem>

      </Form>
    </div>
    <div slot="footer" style='position:relative;clear:both'>
      <!-- 	<Button type="success" class='downcsv' icon="md-arrow-down" @click='downFile'>下载文件</Button> -->
      <!-- <Button type="success" class='downcsv putbox' icon="md-heart-outline" >收藏文件</Button> -->
      <Button type="error" @click='removeItem' class='remove' icon="md-trash" v-if='isnewModal == false'>删除</Button>
      <Button type="default" @click='cancelModal' icon="md-close">取消</Button>
      <Button type="info" @click='saveData' icon="md-checkmark-circle-outline">提交</Button>
      <!-- <Button type="primary" @click='pipeGw' icon="md-checkmark-circle-outline" v-if='targetKeys.length>0'>流转文件</Button> -->
    </div>
  </Modal>
</template>

<script>
import upFile from './upFile'
import upImg from './upImg'
import upImgnew from './upImgnew'
export default {
  name: 'formItem',
  components: {
    upFile,
    upImg,
    upImgnew
  },
  mounted () {
    var userInfo = JSON.parse(localStorage.getItem('inchUserinfo'))
    var that = this
    this.actionUrl = this.baseURL.imgURL
    this.curSchoolid = userInfo.schoolid
    this.getRootName()
    // this.getVideoType()
    this.getAudioType()
    this.getrootData()
    // this.getPartData(userInfo.schoolid)
    // utils.getSchoolData().then(res=>{
    // 	 that.schoolData = JSON.parse(res)[0]['children']

    // })
    // utils.getRoleData().then(res=>{

    // 	 that.roleData = JSON.parse(res)
    // })
    // utils.getPartData(userInfo.schoolid).then(res=>{

    // 	 that.partData = JSON.parse(res)
    // })
    // utils.getLcdData(userInfo.schoolid).then(res=>{

    // 	 that.lcdData = JSON.parse(res)

    // })
    // utils.getSignData().then(res=>{
    // 	 that.signData = JSON.parse(res)

    // })
    // utils.getTeachData().then(res=>{
    // 	that.alluser = res
    // })

  },
  created () {
    //this.initTable = JSON.parse(JSON.stringify(this.formdata[1]))

  },
  props: ['formdata', 'reloadtmp', 'modaltitle'],
  watch: {
    reloadtmp (newval, oldval) {

      if (newval != oldval) {
        this.showData()
      }
    },
    modaltitle (newval, oldval) {
      this.selftitle = newval
    },
    targetKeys (newval, oldval) {
      ////console.log(newval, this.partUserData)
      var checkData = {
        departid: [],
        depart: [],
        selusers: [],
        selusersText: [],
      }
      var that = this
      // that.btnAct = -1
      var partUser = this.partUserData

      partUser.map(function (val, index) {
        val['checkUser'] = 0
        var num = 0
        var _child = val['children']
        _child.map(function (child, index) {
          if (newval.indexOf(child['guid']) > -1) {
            num += 1
            if (checkData['selusers'].indexOf(child['guid']) == -1) {
              checkData['selusers'].push(child['guid'])
            }
            if (checkData['selusersText'].indexOf(child['name']) == -1) {
              checkData['selusersText'].push(child['name'])
            }
          }
        })
        if (num > 0) {
          checkData['departid'].push(val['id'])
          checkData['depart'].push(val['name'])
          // that.btnAct = index
        }
        val['checkUser'] = num
      })


      checkData['selusers'] = checkData['selusers'].join(',')
      checkData['selusersText'] = checkData['selusersText'].join(',')
      checkData['departid'] = checkData['departid'].join(',')
      checkData['depart'] = checkData['depart'].join(',')
      this.checkPartUser = checkData
      this.partUserData = partUser
    }

  },
  data () {
    return {
      rootData: [],
      maxnum: 100000,
      minnum: -100000,
      appcenterData: [],
      selftitle: '编辑',
      editorHtml: '',
      isnewModal: true,
      storeimg: [], //临时存储img
      signData: [],
      lcdData: [],
      partData: [],
      roleData: [],
      schoolData: [],
      selfUrl: '', // 自定义模板url
      curSchoolid: -1,
      alluser: [],
      targetUser: [],
      b_part: [], //备用的部门
      b_user: [], //备用的用户
      checkPartUser: {},
      targetKeys: [], // 选中的target
      btnAct: -1, //选中的部门
      users: [], // 选择的人员
      usersid: '', // 选择人员的id
      companyid: '', // 选择部门id
      choseUserGroup: [], //不同组组合在一起的人员
      partUserData: [], //部门加人员数据
      objlist: [{
        value: '111',
        name: '政治'
      }, {
        value: '1sdaf',
        name: '语文'
      }, {
        value: '222',
        name: '地理'
      }, {
        value: '2asdfsdfas',
        name: "数学"
      }, {
        value: '333',
        name: '历史'
      }, {
        value: '3cc09312-6696-11ea-a43c-7cd30adab904',
        name: '健康管理'
      }, {
        value: '3sadfsadf',
        name: "物理"
      }, {
        value: '444',
        name: '英语'
      }, {
        value: '4sadfsa',
        name: '化学'
      }, {
        value: '5sadf',
        name: "生物"
      }, {
        value: 'bd80be1c-ec01-11e9-ab18-7cd30adaa218',
        name: '书法'
      }, {
        value: 'c25a4d94-ec01-11e9-ab18-7cd30adaa218',
        name: '作文'
      }],
      treekey: -1,
      ischeck: true,
      checkSchool: [],
      showModal: false,
      initTable: [],
      rangeTime: [],
      schoolData: [],
      initSchoolData: [],
      videoUrl: '',
      audioUrl: '',
      selfFormData: [{
        type: 'tree',
        ischeck: true,
        model: [],
        name: 'classid'
      },
      {
        type: 'rangetime',
        title: '开始时间~结束时间',
        children: [{
          name: 'begintime',
          title: '',
          model: ''
        }, {
          name: 'endtime',
          title: '',
          model: ''
        }]
      },
      {
        type: 'textarea',
        title: '欢迎词或考场内容（可手工换行）',
        name: 'content',
        model: ''
      },
      {
        type: 'input',
        title: '考试名称（欢迎词时不填）',
        name: 'ticketno',
        model: ''
      },
      {
        type: 'textarea',
        title: '准考证号段（欢迎词时不填）',
        name: 'exam',
        model: ''
      },
      {
        type: 'select',
        title: '背景',
        placeholder: '请选择背景',
        name: 'bgcolor',
        model: '0',
        children: [{
          title: '淡雅蓝',
          value: '2'
        }, {
          title: '淡雅红',
          value: '0'
        }, {
          title: '党建红',
          value: '1'
        }, {
          title: '淡雅橙',
          value: '3'
        }]
      },
      {
        type: 'checkbox',
        title: '显示方式',
        children: [{
          name: 'unshared',
          title: '独占方式显示（遮挡所有画面）',
          model: false
        }]
      },
      {
        type: 'hidden',
        children: [{
          name: 'guid',
          model: ''
        }, {
          name: 'oldclassid',
          model: ''
        }]
      },
      {
        label: '开始时间',
        prop: 'begintime'
      },
      {
        label: '结束时间',
        prop: 'endtime'
      },
      {
        label: '作业标题',
        prop: 'title'
      },
      {
        label: '内容',
        prop: 'notice'
      },
      {
        label: '屏上显示',
        prop: 'isscreen',
        type: 'checkbox'
      },
      {
        label: '家长可读',
        prop: 'isparent',
        type: 'checkbox'
      },
      {
        label: '欢迎词或考场内容（可手工换行）',
        prop: 'content'
      },
      {
        label: '准考证号段（欢迎词时不填）（可手工换行）',
        prop: 'ticketno'
      },
      {
        label: '背景',
        prop: 'bgcolor',
        type: 'select',
        value: [{
          value: 2,
          name: "淡雅蓝"
        }, {
          value: 0,
          name: '淡雅红'
        }, {
          value: 1,
          name: '党建红'
        }, {
          value: 3,
          name: '淡雅橙'
        }]
      },
      {
        label: '显示方式',
        prop: 'unshared',
        type: 'checkbox',
        text: '独占方式显示（遮挡所有画面）'
      },
      {
        label: '科目',
        prop: 'type',
        type: 'select',
        value: [{
          value: '111',
          name: '政治'
        }, {
          value: '1sdaf',
          name: '语文'
        }, {
          value: '222',
          name: '地理'
        }, {
          value: '2asdfsdfas',
          name: "数学"
        }, {
          value: '333',
          name: '历史'
        }, {
          value: '3cc09312-6696-11ea-a43c-7cd30adab904',
          name: '健康管理'
        }, {
          value: '3sadfsadf',
          name: "物理"
        }, {
          value: '444',
          name: '英语'
        }, {
          value: '4sadfsa',
          name: '化学'
        }, {
          value: '5sadf',
          name: "生物"
        }, {
          value: 'bd80be1c-ec01-11e9-ab18-7cd30adaa218',
          name: '书法'
        }, {
          value: 'c25a4d94-ec01-11e9-ab18-7cd30adaa218',
          name: '作文'
        }]
      },
      {
        label: '视频地址',
        prop: 'videourl'
      },
      {
        label: '考试日期',
        prop: 'examtime'
      },
      {
        label: '备注',
        prop: 'remark'
      },
      {
        label: '成绩文件',
        prop: 'filename'
      },
      {
        label: '相册名称',
        prop: 'title'
      },
      {
        label: '姓名',
        prop: 'name'
      },
      {
        label: '学号',
        prop: 'stucode'
      },
      {
        label: '物理卡号',
        prop: 'realcard'
      },
      {
        label: '宿舍编号',
        prop: 'dormid'
      },
      {
        label: '科目',
        prop: 'isFee',
        type: 'select',
        value: [{
          value: '2',
          name: '未交费'
        }, {
          value: '1',
          name: '已交费'
        }]
      },
      {
        label: '学生姓名',
        prop: 'studentname'
      },
      {
        label: '家长姓名',
        prop: 'parentname'
      },
      {
        label: '家长手机号码',
        prop: 'phone'
      },
      {
        label: '考试名称（欢迎词时不填） ',
        prop: 'exam'
      },
      {
        label: '网络链接（直接跳转） ',
        prop: 'url'
      },
      {
        label: '描述',
        prop: 'describ'
      },
      ],
      actionUrl: '',
      videoData: [],
      audioData: [],
    }
  },


  methods: {
    getrootData () {
      var that = this
      that.axios.get('dic/getQueryList', {
        params: {
          length: -1,
          pid: '0',
          rootid: 'news'
        }
      }).then(res => {
        ////console.log(res)
        that.rootData = res.data
      })
    },
    getAudioType () {
      var that = this
      that.axios.get('dic/getQueryList', {
        params: {
          length: -1,
          rootid: 'audio'
        }
      }).then(res => {
        ////console.log(res)
        that.audioData = res.data
      })
    },
    getVideoType () {
      var that = this
      that.axios.get('dic/getQueryList', {
        params: {
          length: -1,
          rootid: 'video'
        }
      }).then(res => {
        ////console.log(res)
        that.videoData = res.data
      })
    },
    getwjnoRootName () {
      var that = this
      that.axios.get('dic/getQueryList', {
        params: {
          length: -1,
          rootid: 'wjno'
        }
      }).then(res => {
        ////console.log(res)
        that.appcenterData = res.data
      })
    },
    getRootName () {
      var that = this
      that.axios.get('dic/getQueryList', {
        params: {
          length: -1,
          rootid: 'appcenter'
        }
      }).then(res => {
        ////console.log(res)
        that.appcenterData = res.data
      })
    },
    showData () {
      var that = this
      this.showModal = true
      var param = this.getUrlParam(this.formdata[0][0])
      var url = this.formdata[0][0].split("?")[0]
      console.log(param, url, 'urlparam', this.formdata[1])
      if (url == 'video/getId') {
        this.getVideoType()
      }
      this.editorHtml = ''
      if (this.$refs['videoUpload']) {
        this.$refs['videoUpload'][0].fileList = []
      }
      if (this.$refs['upAudioUpload']) {
        this.$refs['upAudioUpload'][0].fileList = []
      }
      if (param['id'] == -1) {
        that.treekey = Math.random()
        that.checkSchool = []
        that.selfUrl = ''
        that.storeimg = []
        // that.ischeck = this.formdata[1][0]['ischeck']
        // ////console.log(this.formdata[1],'111111111')
        that.formateVal(this.formdata[1], -1)
        that.isnewModal = true

      } else {
        if (param['hasnoremove'] == 0) {
          that.isnewModal = true
        } else {
          that.isnewModal = false
        }

        this.axios.get(url, {
          params: param
        }).then(res => {
          ////console.log(res)
          if (res.classids) {
            res.data['classids'] = res.classids
            res.data['classid'] = res.classids.join(",")
          }
          if (res.items) {
            res.data['item'] = res.items
          }
          if (res.users && res.users.length > 0) {
            res.data['selUser'] = res.users
          }
          if (res.success) {
            // that.ischeck = this.formdata[1][0]['ischeck']
            that.treekey = Math.random()
            that.checkSchool = res.data.classids
            that.formateVal(res.data)
          } else {
            that.$Message.warning(res.msg)
          }

        })
      }

    },
    removeItem () {
      var that = this
      var param = this.getUrlParam(this.formdata[0][0])
      var url = this.formdata[0][0].split("?")[0]
      if (param['id'] == -1) {

      } else {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>是否确认删除</p>',
          onOk: () => {
            this.axios.post(this.formdata[0][2], param).then(res => {
              ////console.log(res)
              that.$Message.info(res.msg)
              that.showModal = false
              that.$emit('reloadModalData', true)
            }).catch(function (err) {
              that.$Message.error(err.msg)
            })

          },
          onCancel: () => {

          }
        });
      }

    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$Message.success('Success!');
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    handleSuccess (res) {
      ////console.log(res)
      this.selfUrl = res.data.file
    },
    pichandleSuccess (res, item) {
      ////console.log(res, item)
    },
    pichandleSuccess2 (res, item) {
      ////console.log(res, item)
    },
    editorContent (val) {
      ////console.log(val)
      this.editorHtml = val
    },
    upImglist (a, b, c) {
      console.log(a, b, c)
      var _name = a.name
      var pics = a.pics
      var arr = []
      for (var i = 0; i < pics.length; i++) {
        var item = pics[i]['response']['url']
        var pic = item.split("@")[0]
        var picsmall = item.split("@")[0]
        var obj = {
          pic: pic,
          picsmall: picsmall,
        }
        arr.push(obj)
      }

      var storeImg = this.storeimg
      if (storeImg.length > 0) {
        for (var j = 0; j < storeImg.length; j++) {
          switch (storeImg[j]['name']) {
            case _name:
              storeImg[j]['children'] = arr
              break;
            default:
              storeImg.push({
                name: _name,
                children: arr
              })
              break;
          }
        }
      } else {
        storeImg.push({
          name: _name,
          children: arr
        })
      }
      console.log(storeImg, 'sss')
      this.storeimg = storeImg

    },
    saveData (a) {
      var param = {}
      var that = this
      var postData = this.formdata[1]
      //console.log(postData, 'postData------')

      postData.map(function (val, index) {

        switch (val['type']) {
          case 'rangetimes':
            val['children'].map(function (child, idx) {
              param[child['name']] = that.formateTime(child['model'])
            })
            break
          case 'rangetime':
            param['begintime'] = that.formateTime(val['model'][0]) || ''
            param['endtime'] = that.formateTime(val['model'][1]) || ''
            break
          case 'date':
            param[val['name']] = that.formateTime(val['model'], 1)
            break
          case 'datetime':
            param[val['name']] = that.formateTime(val['model'])
            break
          case 'checkbox':
            val['children'].map(function (child, idx) {
              var model = child['model'] == true ? 1 : 0
              param[child['name']] = model
            })
            break
          case 'radio':
            var model = val['model'].split('LV')[1]
            param['lv'] = model
            break
          case 'hidden':
            ////console.log(val, 'val---------')
            val['children'].map(function (child, idx) {
              param[child['name']] = child['model'] || ''
              if (child['name'] == 'schoolid') {
                param[child['name']] = that.curSchoolid
              }
              if (child['name'] == 'oldschoolid') {
                param[child['name']] = that.curSchoolid
              }
              if (child['name'] == 'item') {
                param[child['name']] = child['model'] || 0
              }
              if (child['name'] == 'id') {
                param[child['name']] = child['model'] || 0
              }
              if (child['name'] == 'isquan') {
                param[child['name']] = child['model'] || 0
              }
            })
            break
          case 'video':
            param[val['name']] = that.videoUrl
            break
          case 'audio':
            param[val['name']] = that.audioUrl
            break
          case 'select':
            param[val['name']] = val['model']
            break
          case 'switch':
            var model
            if (val['name'] == 'state') {
              model = val['model'] == true ? 0 : 1
            } else {
              model = val['model'] == true ? 1 : 0
            }

            param[val['name']] = model
            break
          case 'selectMutl':
            param[val['name']] = val['model'].join(',')
            break
          case 'partuser':
            ////console.log(that.checkPartUser)
            break
          case 'excelfile':
            param[val['name']] = that.selfUrl
            break
          case 'numberInput':
            param[val['name']] = val['model'] || 0
            break
          case 'selectPart':
            param['depart'] = that.getpartname(val['model'])
            param['usergroup'] = param[val['name']] = val['model'].join(',')
            break
          case 'timerange':
            ////console.log(param)
            if (val['name'] == "signin") {
              param['instarttime'] = val['model'][0]
              param['inendtime'] = val['model'][1]
            } else if (val['name'] == "signout") {
              param['outstarttime'] = val['model'][0]
              param['outendtime'] = val['model'][1]
            } else if (val['name'] == 'dormconfig') {
              param['starttime'] = val['model'][0]
              param['endtime'] = val['model'][1]
            }
            break
          case 'remark':

            break
          case 'wangeditor':
            param[val['name']] = that.editorHtml
            break
          case 'uploadimg':
            //console.log(that.storeimg, '111111')
            param[val['name']] = val['model'] || ''
            var newpics = []
            if (that.storeimg && that.storeimg.length > 0) {
              for (var i = 0; i < that.storeimg.length; i++) {
                var lendata = that.storeimg[i]['children']
                for (var j = 0; j < lendata.length; j++) {
                  newpics.push(lendata[j]['pic'])
                }
              }
              param[val['name']] = newpics.join(',')
            }

            break
          case 'upImgnew':
            //console.log(that.storeimg, '111111')
            param[val['name']] = val['model'] || ''
            if (that.storeimg && that.storeimg.length > 0) {
              for (var i = 0; i < that.storeimg.length; i++) {
                if (that.storeimg[i]['name'] == 'pic') {
                  param['picsmall'] = that.storeimg[i]['children'][0]['picsmall']
                  param['pic'] = that.storeimg[i]['children'][0]['pic']
                } else {
                  // param[that.storeimg[i]['name']] = that.storeimg[i]['children'][0]['picsmall']
                  param[that.storeimg[i]['name']] += that.storeimg[i]['children'][0]['pic']
                }

              }
            }

            break
          default:
            param[val['name']] = val['model'] || ''


        }
      })
      ////console.log(param, 'param')
      if (param['password']) {
        param['kpassword'] = param['password']
      }
      if (param['title'] == '') {
        that.$Message.info('请填写标题')
        return false;
      }
      if (['broadcast/save'].indexOf(this.formdata[0][1]) > -1) {

      } else {
        if (param['begintime']) {
          param['begintime'] = param['begintime'] + ':00'
        }
        if (param['endtime']) {
          param['endtime'] = param['endtime'] + ':00'
        }
      }

      if (this.formdata[0][1] == 'video/save') {
        if (param['itemid'] == '') {
          that.$Message.info('请选择所属类别')
          return false;
        }
        if (param['url'] == '') {
          that.$Message.info('请上传视频')
          return false;
        }
        if (param['pic'] == '') {
          that.$Message.info('请上传背景图')
          return false;
        }

      }

      this.axios.post(this.formdata[0][1], param).then((res, back) => {
        //console.log(res, back)
        if (res.success) {
          that.$Message.success(res.msg)
          that.showModal = false
          that.$emit('reloadModalData', true)
          if (that.$refs['videoUpload']) {
            that.$refs['videoUpload'][0].clearFiles()
          }
          that.storeimg = []
        } else {
          that.$Message.error(res.msg)
        }
      })
    },
    formateVal (data, isnew) {
      ////console.log(data, 'data')
      var that = this
      if (isnew != -1) {
        for (var key in data) {
          if (key == 'lv') {
            data['lv'] = 'LV' + data['lv']
          }
          if (['isparent', 'isscreen', 'unshared', 'islock', 'ispublic', 'isapp', 'isweb', 'isdel', 'isoriginal'].indexOf(
            key) > -1) {
            data[key] = data[key] == 0 ? false : true
          }
          // if (['notice', 'title', 'content'].indexOf(key) > -1) {
          // 	data[key] = decodeURIComponent(data[key])
          // }
          if (['selUser'].indexOf(key) > -1) {
            that.targetKeys = data[key]
          }
          if (key == 'goodList') {
            var _data = data['goodList']
            var htmlstr = ''
            if (_data != null && _data.length > 0) {

              for (var item = 0; item < _data.length; item++) {
                var itemData = _data[item];
                htmlstr += itemData.goodname + "*" + itemData.num;
              }
              data['goodlists'] = htmlstr
            }

          }

        }
        var formateData = that.renderData(data)
        ////console.log(formateData, '111111111')
        that.formdata[1] = formateData
        that.$forceUpdate();
      } else {
        that.formdata[1] = data
        that.$forceUpdate();
      }
    },
    changeClass (val) {
      ////console.log(val)
      // this.formdata[1][0]['model'] = val['classid']
    },
    renderUser (val, index, child) {
      this.btnAct = index
      var that = this
      // that.axios.get('depart/loadDepartUser', {params:{departid:val}}).then((back) => {

      child.map(function (val, index) {
        val['label'] = val['name']
        val['key'] = val['guid']
      })

      that.users = child

      // })
    },
    changeUser (val, c, d) {
      ////console.log(val, c, d)
      this.targetKeys = val
      this.choseUserGroup = JSON.parse(JSON.stringify(this.targetKeys))
    },
    changeUsers (val, c, d) {
      ////console.log(val, c, d)
      this.targetUser = val
      // this.choseUserGroup = JSON.parse(JSON.stringify(this.targetKeys))
    },
    getpartname (val) {
      var partname = []
      var parts = this.partUserData
      ////console.log(val, parts)
      for (var i = 0; i < parts.length; i++) {
        for (var j = 0; j < val.length; j++) {
          if (parts[i]['id'] == val[j]) {
            partname.push(parts[i]['name'])
          }
        }
      }
      return partname.join(',')
    },
    getPartData (schoolid) {
      var that = this
      var person = []
      that.axios.get('depart/loadDepart', {
        params: {
          schoolid: schoolid,
          // type:1,
        }
      }).then((a) => {
        that.b_part = a

        a.map(function (user, index) {

          that.axios.get('depart/loadDepartUser', {
            params: {
              departid: user.id
            }
          }).then((b) => {
            person.push(b)
            user['children'] = b


          })
        })

        that.partUserData = a
        that.b_user = person
      })


    },
    formateTime (data, type) {
      if (!data) {
        return ''
      }
      var d = new Date(data);
      var month = (d.getMonth() + 1) > 9 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)
      var date = d.getDate() > 9 ? d.getDate() : '0' + d.getDate()
      var hours = d.getHours() > 9 ? d.getHours() : '0' + d.getHours()
      var minutes = d.getMinutes() > 9 ? d.getMinutes() : '0' + d.getMinutes()
      var seconds = d.getSeconds() > 9 ? d.getSeconds() : '0' + d.getSeconds()
      var time = d.getFullYear() + '-' + month + '-' + date + ' ' + hours + ':' + minutes
      ////console.log(data, time)
      if (type == 1) {
        return d.getFullYear() + '-' + month + '-' + date
      }
      return time
    },
    renderData (data) {
      var _currentData = this.formdata[1]
      var that = this

      for (var i = 0; i < _currentData.length; i++) {
        if (_currentData[i]['type'] == "video") {
          that.videoUrl = data['url']
        }
        if (_currentData[i]['type'] == "audio") {
          that.audioUrl = data['url']
        }

        if (['numberInput'].indexOf(_currentData[i]['type']) > -1) {

          _currentData[i]['model'] = Number(data[_currentData[i]['name']])
          // _currentData[i]['model'] = data[_currentData[i]['name']]
          ////console.log(_currentData[i]['model'],'--->')
        } else if (['checkbox', 'hidden'].indexOf(_currentData[i]['type']) > -1) {

          _currentData[i]['children'].map(function (val, index) {
            if (['enableTeach', 'enableStu', 'enablePar', 'enableStaff', 'enableDorm', 'isapp',
              'isweb'
            ].indexOf(val[
              'name']) > -1) {
              //console.log(val['model'], data[val['name']], val['name'], '------>')
              val['model'] = data[val['name']]
              // val['model'] = val['model'] == 1 ? true : false
            } else {

              val['model'] = data[val['name']] ? data[val['name']] : val['model']
            }


          })
        } else if (['rangetime'].indexOf(_currentData[i]['type']) > -1) {
          _currentData[i]['model'] = []
          _currentData[i]['model'].push(data['begintime'])
          _currentData[i]['model'].push(data['endtime'])
        } else if (['select'].indexOf(_currentData[i]['type']) > -1) {

          _currentData[i]['model'] = data[_currentData[i]['name']]

        } else if (['switch'].indexOf(_currentData[i]['type']) > -1) {

          if (_currentData[i]['name'] == 'state') {
            _currentData[i]['model'] = data[_currentData[i]['name']] == '0' ? true : false
          } else if (_currentData[i]['name'] == 'isauto') {

            var isauto = data[_currentData[i]['name']]
            _currentData[i]['model'] = isauto == '0' ? false : true
          } else {
            _currentData[i]['model'] = data[_currentData[i]['name']]
          }


        } else if (['selectPart'].indexOf(_currentData[i]['type']) > -1) {

          // _currentData[i]['model'] = data[_currentData[i]['name']]

          var datas = data['usergroup'].split(',')
          for (var k = 0; k < datas.length; k++) {
            datas[k] = Number(datas[k])
          }

          _currentData[i]['model'] = datas


        } else if (['date'].indexOf(_currentData[i]['type']) > -1) {
          _currentData[i]['model'] = data[_currentData[i]['name']] || ''

        } else if (['excelfile'].indexOf(_currentData[i]['type']) > -1) {

          _currentData[i]['model'] = that.selfUrl = data[_currentData[i]['name']] || ''

        } else if (['timerange'].indexOf(_currentData[i]['type']) > -1) {
          if (_currentData[i]['name'] == 'signin') {
            _currentData[i]['model'] = []
            _currentData[i]['model'].push(data['instarttime'])
            _currentData[i]['model'].push(data['inendtime'])
          } else if (_currentData[i]['name'] == 'signout') {
            _currentData[i]['model'] = []
            _currentData[i]['model'].push(data['outstarttime'])
            _currentData[i]['model'].push(data['outendtime'])
          } else if (_currentData[i]['name'] == 'dormconfig') {
            _currentData[i]['model'] = []
            _currentData[i]['model'].push(data['starttime'])
            _currentData[i]['model'].push(data['endtime'])
          }


        } else if (['multSelect'].indexOf(_currentData[i]['type']) > -1) {
          ////console.log(_currentData[i]['name'], data[_currentData[i]['name']])
          _currentData[i]['model'] = data[_currentData[i]['name']] ? data[_currentData[i]['name']].split(',') : []
        } else if (_currentData[i]['name']) {
          if (["msgContent"].indexOf(_currentData[i]['name']) > -1) {
            _currentData[i]['model'] = decodeURIComponent(data[_currentData[i]['name']]) || ''
          } else {
            _currentData[i]['model'] = data[_currentData[i]['name']] || ''
          }


        }

      }
      ////console.log(_currentData)

      return _currentData
    },
    cancelModal () {
      this.showModal = false
    },
    getUrlParam (str) {
      // 创建目标对象
      var obj = {}
      var params = str.split("?")[1]
      if (params) {

        params = params.split("&")

        params.map(function (val, index) {

          var _key = val.split('=')[0],
            _val = val.split('=')[1];

          obj[_key] = _val
        })

        return obj
      }
    },
    upVideo (a, b, c) {
      ////console.log(this.$refs['videoUpload'][0].fileList, this.$refs['videoUpload'][0].fileList.length)
      if (this.$refs['videoUpload'][0].fileList.length > 1) {
        this.$refs['videoUpload'][0].fileList.splice(0, 1)
      }
      //this.$refs['videoUpload'][0].clearFiles()
      this.videoUrl = a.url
    },
    upAudio (a, b, c) {
      console.log(this.$refs['upAudioUpload'][0].fileList, this.$refs['upAudioUpload'][0].fileList.length)
      if (this.$refs['upAudioUpload'][0].fileList.length > 1) {
        this.$refs['upAudioUpload'][0].fileList.splice(0, 1)
      }
      //this.$refs['videoUpload'][0].clearFiles()

      var _formItem = this.formdata
      _formItem[1].map(function (val, index) {
        if (val['type'] == 'audio') {
          val['model'] = a.url
        }
      })

      this.$Message.info('音频上传成功')
      this.audioUrl = a.url
    },
    handleFormatError (file) {
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: '请选择mp4格式文件'
      });
    },
    handleFormatErrorAudio (file) {
      his.$Notice.warning({
        title: '文件格式不正确',
        desc: '请选择mp3格式文件'
      });
    },
    getPhotoList () {

    },
  }
}
</script>

<style scoped>
.modalUl {
  width: 100%;
  display: flex;
  justify-content: space-between;


}

.modalUl li {
  list-style: none;

}

.modalUl>li:first-of-type {
  width: 35%;
  height: 100%;
  height: 400px;
  /* 	overflow-y:scroll; */
  overflow-x: hidden;
}

.modalUl>li:last-of-type {
  flex: 1;
  padding-left: 30px;
}

.pickerview {
  overflow: visible;
}

.pickerview .ivu-date-picker {
  float: left;
}

.pickerview .ivu-date-picker:last-of-type {
  float: right;
}

.remove {
  position: absolute;
  left: 0px;
  top: 0px;
}

.ivu-form-item.act {
  clear: both;
}

form:nth-of-type(odd) .ivu-form-item.nor {
  width: 48%;
  float: left;
}

form:nth-of-type(even) .ivu-form-item.nor {
  width: 48%;
  float: right;
}

#partGroup[data-v-70d15d9b] {
  margin-top: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  clear: both;
  width: 100%;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

#partGroup .ivu-btn {
  margin: 8px 8px 8px 0px
}

#partGroup .ivu-btn-success {
  background: #fff;
  color: #515a6e;
  border: 1px solid #c5c8ce;
}

#partGroup .ivu-btn-success.active,
.ivu-btn-success:active {
  background-color: #47cb89 !important;
  border-color: #47cb89 !important;
  color: #fff;
}

#partGroup .btnNor {
  background-color: #edfcf6;
  color: #00d186;
  border: 1px solid #00d186;
}

.ivu-alert-message {
  line-height: 30px
}

.ivu-form {}
</style>
